// The supplier's IDENTITY fields — the only things a hosted document may
// prefill, and the one place their real column names live.
//
// WHY THIS EXISTS: the columns are `supplier_reg_number`, `supplier_vat_number`
// and five separate address columns. Code kept reading `reg_number`,
// `vat_number` and `address`, which simply don't exist. Where the row came from
// `suppliers(*)` that failed SILENTLY — the prefill was blank and nobody could
// tell whether the supplier just hadn't given us a VAT number. Where the
// columns were named explicitly it was worse: PostgREST fails the WHOLE query
// on one unknown column, so the delegation lookup 500'd and the delegate's link
// simply didn't work.
//
// Anything that prefills a document reads from here.

// Exactly the columns a document may prefill. Safe to hand to an
// unauthenticated caller — identity only, nothing commercial, no bank details.
export const SUPPLIER_IDENTITY_COLUMNS = [
  'id',
  'supplier_name',
  'supplier_company_legal_name',
  'supplier_reg_number',
  'supplier_vat_number',
  'supplier_address_line_1',
  'supplier_address_line_2',
  'supplier_address_line_3',
  'supplier_town',
  'supplier_postcode',
];

export const SUPPLIER_IDENTITY_SELECT = SUPPLIER_IDENTITY_COLUMNS.join(', ');

/** The registered address as one line, blank parts dropped. */
export function supplierAddress(s) {
  if (!s) return '';
  return [
    s.supplier_address_line_1,
    s.supplier_address_line_2,
    s.supplier_address_line_3,
    s.supplier_town,
    s.supplier_postcode,
  ].map(v => String(v || '').trim()).filter(Boolean).join(', ');
}

/**
 * The identity values a hosted document prefills, keyed by FIELD_SOURCES.
 * Legal name wins over trading name where both exist — a document is signed by
 * the legal entity.
 */
export function supplierIdentity(s, { todayLabel = '' } = {}) {
  return {
    company_name: (s?.supplier_company_legal_name || s?.supplier_name || '').trim(),
    company_number: (s?.supplier_reg_number || '').trim(),
    vat_number: (s?.supplier_vat_number || '').trim(),
    registered_address: supplierAddress(s),
    today: todayLabel,
  };
}
